import { render } from "./CoursewareForm.vue?vue&type=template&id=2ca6c14e&scoped=true"
import script from "./CoursewareForm.vue?vue&type=script&lang=js"
export * from "./CoursewareForm.vue?vue&type=script&lang=js"

import "./CoursewareForm.vue?vue&type=style&index=0&id=2ca6c14e&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-2ca6c14e"

export default script